import React, { useState, useEffect } from "react"
import Select from "../../../components/Select"
import ScheduleCalendar from "./ScheduleCalendar/"
import cfIconLogo from "../../../assets/candlefish_icon_logo.png"

const Main = ({
  categoryOptions,
  categorySelected,
  handleSelect,
  themeColor,
  handleSetView,
  setSelectedEvent,
  appointmentsData,
  setAppointments,
  storeId,
  setStoreId,
}) => {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    async function getAppointments() {
      try {
        // const shop = window.location.ancestorOrigins[0].replace('https://', '')
        const urlParams = new URLSearchParams(window.location.search)
        const storeId = urlParams.get("store")

        setStoreId(storeId)

        const appointmentListUrl = categorySelected
          ? `/appointment-list/${categorySelected}?shop=${storeId}`
          : `/appointment-list/?shop=${storeId}`
        const endpoints = [appointmentListUrl]

        const responses = await Promise.all(
          endpoints.map(async (url) => {
            const response = await fetch(
              `${process.env.REACT_APP_SERVER}${url}`
            )
            return await response.json()
          })
        )

        const appointments = responses[0].data ? responses[0].data : []

        setAppointments(appointments)
        setLoading(false)
      } catch (error) {
        console.log(error)
        setLoading(false)
      }
    }

    getAppointments()
  }, [categorySelected])

  return (
    <>
      <div
        className="ct-modal__control--spacing"
        style={{ display: "flex", justifyContent: "space-between", height: 70 }}
      >
        <div style={{ flex: 1 }}>
          {!categorySelected && (
            <span
              style={{
                display: "block",
                fontSize: "16px",
                color: "#fd6a4f",
                fontWeight: 500,
                padding: "0 0 4px 4px",
              }}
            >
              Select Your Location:
            </span>
          )}
          <Select
            options={categoryOptions}
            selectedOption={categorySelected}
            handleChange={handleSelect}
            color={themeColor}
            width="250px"
          />
        </div>
      </div>
      {categorySelected && !loading && (
        <ScheduleCalendar
          appointmentsData={appointmentsData}
          categorySelected={categorySelected}
          handleSetView={handleSetView}
          setSelectedEvent={setSelectedEvent}
          storeId={storeId}
        />
      )}
      {/* {appointments.length !== 0 &&
        appointments.map((appointment) => {
          if (appointment.visible === 0) {
            return null
          }
          return (
            appointment.category === categorySelected && (
              <AppointmentCard
                key={appointment.id}
                appointment={appointment}
                color={themeColor}
                updateQuantity={updateQuantity}
                handleSetView={handleSetView}
              />
            )
          )
        })} */}
      {categorySelected === "" && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <img src={cfIconLogo} alt="Candlefish" />
          </div>
          <span
            style={{
              fontSize: "20px",
              color: "#fd6a4f",
              fontWeight: 700,
            }}
          >
            Please select a location
          </span>
        </div>
      )}
    </>
  )
}

export default Main
